<template>
  <div class="chart-container">
    <p class="chart-title">{{ title }}</p>
      <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    }
  }
};
</script>

<style scoped>
.chart-container {
  max-width: 100%;
  margin: 0 auto 25px;
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid #E5E5E7;
  border-radius: 12px;
}

.chart-title {
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  color: #6B7280;
  text-align: left;
  border-bottom: 1px solid #E5E5E7;
  margin: 0 0 16px;
  padding: 0 16px 16px;
}
</style>
